import React from 'react';
import { ArrowRight, Star } from 'lucide-react';

const TestimonialsSection = () => {
  const testimonials = [
    {
      quote: "Farzeen's guidance completely transformed my approach to earning online. Within 3 months, my mindset changed, I built confidence and clarity on how to show up and stop doubting and take action- she is there every step of the way and truly gets it! I learned and built income from home while being home with my 7 month old baby!",
      name: "Maryam A.",
      title: "Stay-at-home Mom",
      result: "Transformed in 3 months"
    },
    {
      quote: "I was skeptical at first, I had tried building before but would be burnt out after work. I'm so glad I found her! The step-by-step guidance made everything so clear. Made my first $1K month, straight from my phone while working my full time job, I love her approach, real genuine support and answers all my questions! I learned at my pace and she helped build my online systems!",
      name: "Anam D.",
      title: "Content Creator",
      result: "First $1K month"
    },
    {
      quote: "The BFB method is exactly what I needed. In the ruts of separation and a toddler mom rebuilding life again I had enough on my plate I simply needed clear direction Farzeen did exactly that, she got it! Simplified while I learned from DWA and set up my systems so I was ready to start! I wish I had started sooner, now I'm making extra $500 weekly straight from home!",
      name: "Amanda K.",
      title: "Toddler Mom",
      result: "$500 weekly from home"
    },
    {
      quote: "I Made $12K in Sales in Just 3 Weeks!! I finally locked in and went all-in on my business, and the results speak for themselves—$12,000 in just 3 weeks!! I still can't believe it! This didn't happen overnight. It took strategy, consistency, and execution. I focused, applied the right methods, and now I'm seeing the results. The best part? This is just the beginning!",
      name: "Katie Wilson",
      title: "DWA Digital Marketer",
      result: "$12K in 3 weeks"
    }
  ];

  return (
    <section id="testimonials" className="py-32" style={{ backgroundColor: '#f8f6f3' }}>
      <div className="container mx-auto px-8">
        {/* Header */}
        <div className="text-center mb-20 max-w-3xl mx-auto">
          <p className="text-xs tracking-[0.3em] mb-6 font-light" style={{ color: '#8b7355' }}>
            SUCCESS STORIES
          </p>
          <h2 
            className="text-3xl md:text-4xl lg:text-5xl font-light leading-tight"
            style={{ fontFamily: "'Playfair Display', serif", color: '#1a1a1a' }}
          >
            Words from those who've
            <br />
            <span className="italic" style={{ color: '#8b7355' }}>transformed their lives</span>
          </h2>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-16">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="p-10 transition-all duration-300"
              style={{ backgroundColor: '#ffffff' }}
            >
              {/* Stars */}
              <div className="flex gap-1 mb-6">
                {[1, 2, 3, 4, 5].map((i) => (
                  <Star key={i} size={14} fill="#8b7355" stroke="none" />
                ))}
              </div>
              
              {/* Quote */}
              <p 
                className="text-lg font-light leading-relaxed mb-8 italic"
                style={{ fontFamily: "'Playfair Display', serif", color: '#1a1a1a' }}
              >
                "{testimonial.quote}"
              </p>
              
              {/* Author */}
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium" style={{ color: '#1a1a1a' }}>{testimonial.name}</p>
                  <p className="text-xs font-light" style={{ color: '#666' }}>{testimonial.title}</p>
                </div>
                <span 
                  className="text-[10px] tracking-[0.15em] px-3 py-1"
                  style={{ backgroundColor: '#f8f6f3', color: '#8b7355' }}
                >
                  {testimonial.result}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <p className="text-base font-light mb-6" style={{ color: '#666' }}>
            Ready to write your own success story?
          </p>
          <a 
            href="https://stan.store/FarzeenDigitalWealth/p/lets-chat-book-your-free-15-min-clarity-call"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 border text-xs tracking-[0.15em] px-10 py-4 transition-all duration-300 hover:bg-[#1a1a1a] hover:text-white"
            style={{ borderColor: '#1a1a1a', color: '#1a1a1a' }}
          >
            BOOK YOUR FREE CLARITY CALL
            <ArrowRight size={16} strokeWidth={1.5} />
          </a>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
